import { createSelector } from "@reduxjs/toolkit";

export const getModalTriggerElement = (state) => state.offerModal.triggerElement;

export const getOfferModalData = createSelector([(state) => state.offerModal], (offerModal) => {
  return {
    isOpen: offerModal.isOpen,
    storeKey: offerModal.storeKey,
    props: offerModal.modalProps || {},
    loading: offerModal.loading,
    error: offerModal.error,
  };
});

export const getContextModalData = createSelector([(state) => state.offerModal], (offerModal) => {
  return {
    isOpen: offerModal.isOpen,
    storeKey: offerModal.storeKey,
    props: offerModal.modalProps || {},
  };
});
